unit UserItemType;
{

/* Initial. */

}

interface

type
  TUserItemType = class
  private
    fUserKey: String;
    fLoginName: String;
    fFullName: String;
    fFunctionName: String;
    fIsAdmin: Boolean;
    fLoggedIn: Boolean;
    fActive: Boolean;
  public
    property UserKey: String read fUserKey;
    property LoginName: String read fLoginName;
    property FullName: String read fFullName;
    property FunctionName: String read fFunctionName;
    property IsAdmin: Boolean read fIsAdmin;
    property LoggedIn: Boolean read fLoggedIn;
    property Active: Boolean read fActive;
  end;

implementation

end.
